import { StateType } from 'data/types'
import { createSelector } from 'reselect'

export const getRawCurrencies = (state: StateType) => state.payments.currencies.data

export const getCurrencies = createSelector(getRawCurrencies, (currencies) =>
  currencies.filter((c) => !c.blocked).map((c) => c.key)
)
